<template>
    <div id="holzrestaurierung" class="pt-8">
        <v-container class="mt-5 mb-5">
            <h1>Mauerwerk</h1>
            <p></p>
            
        <v-layout row wrap class="mt-2">
            <v-flex v-for="item in serviceItems" :key="item.description" xs10 offset-xs1 offset-sm0 sm6 lg3 class="py-2">
            <v-card
                class="ma-2"
                height="100%"
            >
                <v-img
                :src="item.source"
                ></v-img>

                <v-card-text>
                        {{ item.description }}
                    </v-card-text>

            </v-card>
            </v-flex>
        </v-layout>

        </v-container>
    </div>
</template>

<script>
  export default {
    data: () => ({
     serviceItems: [
       {description: 'Fachwerkausmauerung mit Lehmsteinen', 
       source: require('../assets/mauern1.jpg')},
       {description: 'Zuschnitt von Mauerziegel', 
       source: require('../assets/mauern3.jpg')},
       {description: 'Ziegelmauerwerk in einem Gebäude', 
       source: require('../assets/mauern2.jpg')},
     ]
    }),
  }
</script>